<template>
    <!-- Side Menu -->
    <div class="p-nav__sidemenu mypage-nav is-hide">
        <div class="side-menu mypage-nav__inner">
            <!-- nav -->
            <ul class="side-menu__list">
                <li><router-link :to="{ name: 'news.list'}">{{ $t('LABEL_NEWS') }}</router-link></li>
                <li><router-link :to="{ name: 'contact.us' }">{{ $t('LABEL_ENQUIRY') }}</router-link></li>
                <li><router-link :to="{ name: 'about.hubsynch'}">{{ $t('LABEL_ABOUT_US') }}</router-link></li>
                <li><router-link :to="{ name: 'user.terms'}">{{ $t('LABEL_MERCHANT_TERM_OF_USE') }}</router-link></li>
                <li><router-link id="link-privacy-policy-1" :to="{ name: 'privacy.policy' }">{{ $t('LABEL_PRIVACY_POLICY') }}</router-link></li>
                <li><router-link :to="{ name: 'personal.information'}">{{ $t('LABEL_HANDLING_OF_PERSONAL_DATA') }}</router-link></li>
            </ul>
        </div>
    </div>
</template>